import React, { useContext, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { FirebaseContext } from '../../context/FirebaseContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import { getLibraryCount, getLibraryStatistics } from '../../NecttosComp/APICaller/ApiServices';
import CustomInput from '../../myComp/CustomInput';
import Button from '../../NecttosComp/Button/Button';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

export const exportPdf = async ({ olddata, setLoading }) => {
	const instance = await getAxiosTokenInstance();
	console.log('------->', { olddata });
	let data = {
		...olddata,
	};
	try {
		const resp = await instance.post(`/college/action/getLibrarySelectedDataToExcel`, data, {
			responseType: 'blob',
		});
		if (resp.data.statusCode === 400) {
			setLoading(false);
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp.data;
		}
	} catch (error) {
		setLoading(false);
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

export const LibraryStatisticsExport = ({ onClose }) => {
	const { collegeId } = useContext(FirebaseContext);

	const [stateData, setStateData] = React.useState({
		tBook: true,
	});

	const exportPdfMutation = useMutation(exportPdf);

	const [loading, setLoading] = useState(false);

	const { data: subjectsData = [] } = useQuery(['subjectsData', stateData], getLibraryStatistics({ collegeId, collection: 'bookStocks', key: 'subject', primoryKey: 'true' }));
	const { data: fundData = [] } = useQuery(['fundData1'], getLibraryStatistics({ collegeId, collection: 'bookStocks', key: 'fund', primoryKey: 'true' }));
	const { data: statusData = [] } = useQuery(['statusData2'], getLibraryStatistics({ collegeId, collection: 'bookStocks', key: 'status', primoryKey: 'true' }));
	const { data: categoryData = [] } = useQuery(['categoryData'], getLibraryStatistics({ collegeId, collection: 'bookStocks', key: 'category', primoryKey: 'true' }));

	const { data: languageData = [] } = useQuery(['languageData'], getLibraryStatistics({ collegeId, collection: 'books', key: 'language', primoryKey: 'true' }));
	const { data: typeOfBook = [] } = useQuery(['typeOfBook'], getLibraryStatistics({ collegeId, collection: 'books', key: 'bookType', primoryKey: 'true' }));

	const { data: count = [] } = useQuery(['count', stateData], getLibraryCount({ collegeId, collection: 'bookStocks', stateData }));

	const onExportExam = async () => {
		setLoading(true);
		console.log('=======> etry 1');

		try {
			const link = document.createElement('a');
			link.target = '_blank';
			let olddata = {
				collegeId,
				collection: 'bookStocks',
				stateData,
			};

			link.download = 'Excel';
			console.log('=======> etry 2');

			const pdfData = await exportPdfMutation.mutateAsync({ olddata, setLoading });
			console.log('=======> etry 3');

			link.href = URL.createObjectURL(new Blob([pdfData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
			link.click();
			setLoading(false);

			onClose();
		} catch (e) {}
	};

	return (
		<Main className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
			{loading ? (
				<LoadingAnimation dark />
			) : (
				<div className='bg-slate-100 dark:bg-neutral-700 rounded-lg p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto relative'>
					<Header>
						<Instruction keyId={'libraryStatisticsExport'} />

						<Button type='save' onClick={onExportExam}>
							Export To Excel
						</Button>
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</Header>

					<label className='block text-center text-4xl font-bold mb-4 dark:text-slate-100'>{count}</label>
					<Body className='space-y-6'>
						{!stateData?.ufootprint && (
							<>
								<label className='block text-lg font-semibold mb-2 mt-5 dark:text-slate-100'>Type Stacks</label>
								<div className='flex flex-wrap justify-start gap-4'>
									{typeOfBook.map((categoryKey) => {
										const isChecked = stateData['t' + categoryKey];
										return (
											<div
												key={categoryKey}
												className={`cursor-pointer border rounded-xl px-4 py-2 text-sm font-semibold flex items-center justify-center transition duration-300 ${isChecked ? 'bg-green-100 border-green-600 text-green-800' : 'bg-slate-200 dark:bg-slate-400 border-gray-300 text-gray-800'}`}
												onClick={() =>
													setStateData({
														...stateData,
														['t' + categoryKey]: !isChecked,
													})
												}>
												<input type='checkbox' className='hidden' checked={isChecked} onChange={() => {}} />
												{categoryKey?.toUpperCase()}
											</div>
										);
									})}
								</div>
							</>
						)}

						<label className='block text-lg font-semibold mb-2 mt-5 dark:text-slate-100'>Registers</label>
						<div className='flex flex-wrap justify-start gap-3'>
							{['titles', 'active', 'issue', 'renew', 'return', 'footprint'].map((categoryKey) => {
								const isChecked = stateData['u' + categoryKey];
								return (
									<div
										key={categoryKey}
										className={`cursor-pointer border rounded-xl px-4 py-2 text-xs font-bold transition duration-300 ${isChecked ? 'bg-green-100 border-green-600 text-green-800' : 'bg-slate-200 dark:bg-slate-400 border-gray-300 text-gray-800'}`}
										onClick={() =>
											setStateData({
												...stateData,
												['u' + categoryKey]: !isChecked,
											})
										}>
										{categoryKey.toUpperCase()}
									</div>
								);
							})}
						</div>

						{stateData.utitles || stateData.urenew || stateData?.ufootprint || stateData.uissue || stateData.ureturn || stateData.uactive ? (
							<>
								<label className='block text-lg font-semibold mt-2 dark:text-slate-100'>Date of Invoice</label>
								<div className='flex justify-center gap-4 w-full max-w-md mx-auto'>
									<Input2 type='date' fieldName='Start Date' returnKey='xxStartDate' state={stateData} setState={setStateData} className='w-full' />
									<Input2 type='date' fieldName='End Date' returnKey='xxEndDate' state={stateData} setState={setStateData} className='w-full' />
								</div>

								{stateData.utitles && (
									<>
										<label className='block text-lg font-semibold mt-2 dark:text-slate-100'>Language</label>
										<div className='flex flex-wrap justify-center gap-2'>
											{languageData.map((categoryKey) => (
												<label className='text-xs font-bold text-green-800 mx-2 flex items-center'>
													<input type='checkbox' className='h-3 w-3 mr-2' defaultChecked={stateData['l' + categoryKey]} onChange={() => setStateData({ ...stateData, ['l' + categoryKey]: !stateData['l' + categoryKey] })} />
													{categoryKey}
												</label>
											))}
										</div>
									</>
								)}
							</>
						) : (
							<>
								<label className='block text-lg font-semibold mb-2 mt-5 dark:text-slate-100'>Accession Number</label>
								<div className='flex justify-start gap-4 w-full'>
									<Input2 type='number' fieldName='Start Accession Number' returnKey='zzstartNo' state={stateData} setState={setStateData} className='w-full max-w-xs' />
									<Input2 type='number' fieldName='End Accession Number' returnKey='zzendNo' state={stateData} setState={setStateData} className='w-full max-w-xs' />
								</div>

								<label className='block text-lg font-semibold mb-2 mt-6 dark:text-slate-100'>Date of Invoice</label>
								<div className='flex justify-start gap-4 w-full'>
									<Input2 type='date' fieldName='Start Date' returnKey='xxStartDate' state={stateData} setState={setStateData} className='w-full max-w-xs' />
									<Input2 type='date' fieldName='End Date' returnKey='xxEndDate' state={stateData} setState={setStateData} className='w-full max-w-xs' />
								</div>

								<label className='block text-lg font-semibold mb-4 mt-6 dark:text-slate-100'>Nature of Books</label>
								<div className='flex flex-wrap justify-start gap-4'>
									{statusData.map((categoryKey) => (
										<div key={categoryKey} className={`flex items-center border rounded-xl px-4 py-2 shadow-sm cursor-pointer transition-all duration-200 ${stateData['s' + categoryKey] ? 'bg-green-100 border-green-600 text-green-900' : 'bg-slate-200 dark:bg-slate-400 border-gray-300 text-gray-800'}`}>
											<label className='flex items-center text-sm font-semibold'>
												<input type='checkbox' className='h-4 w-4 mr-2 accent-green-600' defaultChecked={stateData['s' + categoryKey]} onChange={() => setStateData({ ...stateData, ['s' + categoryKey]: !stateData['s' + categoryKey] })} />
												{categoryKey?.toUpperCase()}
											</label>
										</div>
									))}
								</div>

								<label className='block text-lg font-semibold mb-4 mt-6 dark:text-slate-100'>Nature of Category</label>
								<div className='flex flex-wrap justify-start gap-4'>
									{categoryData.map((categoryKey) => (
										<div key={categoryKey} className={`flex items-center border rounded-xl px-4 py-2 shadow-sm cursor-pointer transition-all duration-200 ${stateData['c' + categoryKey] ? 'bg-green-100 border-green-600 text-green-900' : 'bg-slate-200 dark:bg-slate-400 border-gray-300 text-gray-800'}`}>
											<label className='flex items-center text-sm font-semibold'>
												<input type='checkbox' className='h-4 w-4 mr-2 accent-green-600' defaultChecked={stateData['c' + categoryKey]} onChange={() => setStateData({ ...stateData, ['c' + categoryKey]: !stateData['c' + categoryKey] })} />
												{categoryKey?.toUpperCase()}
											</label>
										</div>
									))}
								</div>

								<label className='block text-lg font-semibold mb-4 mt-6 dark:text-slate-100'>Types of Fund</label>
								<div className='flex flex-wrap justify-start gap-4'>
									{fundData.map((categoryKey) => (
										<div key={categoryKey} className={`flex items-center border rounded-xl px-4 py-2 shadow-sm cursor-pointer transition-all duration-200 ${stateData['f' + categoryKey] ? 'bg-green-100 border-green-600 text-green-900' : 'bg-slate-200 dark:bg-slate-400 border-gray-300 text-gray-800'}`}>
											<label className='flex items-center text-sm font-semibold'>
												<input
													type='checkbox'
													className='h-4 w-4 mr-2 accent-green-600'
													defaultChecked={stateData['f' + categoryKey]}
													onChange={() =>
														setStateData({
															...stateData,
															['f' + categoryKey]: !stateData['f' + categoryKey],
														})
													}
												/>
												{categoryKey}
											</label>
										</div>
									))}
								</div>

								<label className='block text-lg font-semibold mb-4 mt-5 dark:text-slate-100'>Subjects</label>
								<div className='flex flex-wrap gap-4'>
									{subjectsData.map((categoryKey) => (
										<div key={categoryKey} className={`flex items-center border rounded-xl px-4 py-2 shadow-sm cursor-pointer transition-all duration-200 ${stateData['b' + categoryKey] ? 'bg-green-100 border-green-600 text-green-900' : 'bg-slate-200 dark:bg-slate-400 border-gray-300 text-gray-800'}`}>
											<label className='flex items-center text-sm font-semibold'>
												<input type='checkbox' className='h-4 w-4 mr-2 accent-green-600' defaultChecked={stateData['b' + categoryKey]} onChange={() => setStateData({ ...stateData, ['b' + categoryKey]: !stateData['b' + categoryKey] })} />
												{categoryKey}
											</label>
										</div>
									))}
								</div>

								<label className='block text-lg font-semibold mb-4 mt-5 dark:text-slate-100'>Select Field To Export</label>
								<div className='flex flex-wrap gap-4'>
									{['Accession Number', 'Call No', 'Name of The Book', 'Subject', 'Status', 'ISBN', 'Name of Author', 'Type', 'Name of Author 2', 'Type 2', 'Name of Author 3', 'Type 3', 'Edition', 'Volume', 'Pages', 'Name Of Publisher', 'Place Of Publication', 'Language', 'Series', 'Contents', 'Price', 'Discount', 'Book Details', 'Year Of Publication', 'DDC Subject', 'Fund', 'InvoiceNumber', 'date', 'Vendor', 'Category'].map((categoryKey) => (
										<div key={categoryKey} className={`flex items-center border rounded-xl px-4 py-2 shadow-sm cursor-pointer transition-all duration-200 ${stateData['y' + categoryKey] ? 'bg-green-100 border-green-600 text-green-900' : 'bg-slate-200 dark:bg-slate-400 border-gray-300 text-gray-800'}`}>
											<label className='flex items-center text-sm font-semibold'>
												<input type='checkbox' className='h-4 w-4 mr-2 accent-green-600' defaultChecked={stateData['y' + categoryKey]} onChange={() => setStateData({ ...stateData, ['y' + categoryKey]: !stateData['y' + categoryKey] })} />
												{categoryKey}
											</label>
										</div>
									))}
								</div>
							</>
						)}
					</Body>
				</div>
			)}
		</Main>
	);
};
